import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { captureTracking } from "@/lib/tracking";

// Bat nguon quang cao tu query string truoc khi React dieu huong lam mat no
captureTracking();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
